import { SEARCH_PAGE } from '@core/ui/navigation/constant';
import { useRouter } from 'next/router';
import React, { Fragment, useContext, useState, useEffect } from 'react';
import CheckBox from '../../../../reusecore/src/elements/Checkbox';
import ListView from '../../../components/ListView';
import { ListLoader } from '../../../components/Placeholder';
import { useMutation, useQuery } from '@apollo/client';
import { GET_SEARCH_POST } from '@core/ui/graphql/Search.query';
import { CURRENCY } from '../../../Config';
import { useAuth } from '../../../contexts/AuthProvider';
import { SearchContext } from '../../../contexts/SearchContext';
import { analytics } from '../../../helpers/firebaseHelper';
import {
  cleanParams,
  createUrl,
  getUrlToState,
  slugify,
} from '../../../helpers/urlHandler';
import ListGrid from 'reusecore/src/elements/ListGrid';
import NoItemFound from '../../../components/NoItemFound';
import OnError from '../../../components/OnError';
import { useTranslation } from 'next-i18next';
import { SearchWrapper } from '../style';
import { SAVE_ALERTS } from '@core/ui/graphql/Mutations';
import { cleanFilters } from '../../../helpers/filterHelper';
import { useToasts } from 'react-toast-notifications';
import Icon from 'react-icons-kit';
import { bell } from 'react-icons-kit/typicons/bell';
import { SpinnerLoader } from '../../../components/Loader/spinnerLoader';
import Button from 'reusecore/src/elements/Button';

import Car from '@core/ui/static/images/categories/img-voitures@2x.jpg?resize&sizes[]=100&sizes[]=200&sizes[]=300';
import CarWebp from '@core/ui/static/images/categories/img-voitures@2x.jpg?resize&sizes[]=100&sizes[]=200&sizes[]=300&format=webp';
import Dress from '@core/ui/static/images/categories/img-vetements@2x.jpg?resize&sizes[]=100&sizes[]=200&sizes[]=300';
import DressWebp from '@core/ui/static/images/categories/img-vetements@2x.jpg?resize&sizes[]=100&sizes[]=200&sizes[]=300&format=webp';
import Immo from '@core/ui/static/images/categories/img-immobilier@2x.jpg?resize&sizes[]=100&sizes[]=200&sizes[]=300';
import ImmoWebp from '@core/ui/static/images/categories/img-immobilier@2x.jpg?resize&sizes[]=100&sizes[]=200&sizes[]=300&format=webp';
import Mobilier from '@core/ui/static/images/categories/img-mobilier@2x.jpg?resize&sizes[]=100&sizes[]=200&sizes[]=300';
import MobilierWebp from '@core/ui/static/images/categories/img-mobilier@2x.jpg?resize&sizes[]=100&sizes[]=200&sizes[]=300&format=webp';
import Phone from '@core/ui/static/images/categories/img-telephonie@2x.jpg?resize&sizes[]=100&sizes[]=200&sizes[]=300';
import PhoneWebp from '@core/ui/static/images/categories/img-telephonie@2x.jpg?resize&sizes[]=100&sizes[]=200&sizes[]=300&format=webp';
import Kite from '@core/ui/static/images/categories/img-sports@2x.jpg?resize&sizes[]=100&sizes[]=200&sizes[]=300';
import KiteWebp from '@core/ui/static/images/categories/img-sports@2x.jpg?resize&sizes[]=100&sizes[]=200&sizes[]=300&format=webp';
import Computer from '@core/ui/static/images/categories/img-informatique@2x.jpg?resize&sizes[]=100&sizes[]=200&sizes[]=300';
import ComputerWebp from '@core/ui/static/images/categories/img-informatique@2x.jpg?resize&sizes[]=100&sizes[]=200&sizes[]=300&format=webp';

const SearchPostItem = ({ category, categorySlug }) => {
  const { isLoggedIn } = useAuth();
  const { i18n, t } = useTranslation();

  const router = useRouter();

  const {
    query: { additionalType: queryAdditionalType = '' },
  } = router;

  const urlState = getUrlToState(category);
  const { state, dispatch } = useContext(SearchContext);
  const [loadingMore, toggleLoading] = useState(false);
  const [appNotReady, setAppNotReady] = useState(true);
  const [savingFilters, setSavingFilters] = useState(false);
  const [checkboxes, setCheckboxes] = useState({
    private: queryAdditionalType === '' || queryAdditionalType === 'private',
    pro: queryAdditionalType === '' || queryAdditionalType === 'pro',
  });
  const { addToast } = useToasts();
  const { data, loading, error, fetchMore } = useQuery(GET_SEARCH_POST, {
    variables: {
      queryVariables: urlState,
    },
    ssr: false,
    fetchPolicy: 'network-only',
  });

  const { searchPosts: { data: searchPosts = [], total: totalPost = 0 } = {} } =
    data || {};

  const postCount = searchPosts.length;

  const [saveFiltersMutation] = useMutation(SAVE_ALERTS);

  const getTitle = total => {
    let _resultsString = t('search.title');
    const { category, town } = urlState;
    let title = '';
    if (category) {
      title = t('category.' + category).toLowerCase();
    }
    if (town) {
      title += ' ' + t('at') + ' ' + town;
    }
    if (Object.keys(urlState).length > 2) {
      if (total < 2) {
        if (total === 0) {
          _resultsString = ' ';
        } else {
          _resultsString =
            total + ' ' + t('ad') + ' ' + title + ' ' + t('found');
        }
      } else {
        _resultsString =
          total + ' ' + t('ads') + ' ' + title + ' ' + t('founds');
      }
    }
    return _resultsString;
  };

  const canSaveFilter = () => {
    return (category || filters) && isLoggedIn;
  };

  const generateTitle = filters => {
    const town = filters.town ? ' ' + t('at') + ' ' + filters.town : '';
    if (filters.text) {
      return t('alert') + ' ' + filters.text + town;
    } else if (filters.category) {
      return t('alert') + ' ' + t('category.' + filters.category) + town;
    } else if (town) {
      return t('Ads') + town;
    } else {
      return t('search.alert.success.title');
    }
  };

  const saveFiltersAction = async filters => {
    if (savingFilters) {
      return;
    }
    if (canSaveFilter()) {
      if (!filters) {
        filters = {};
      }
      setSavingFilters(true);
      if (category) {
        filters.category = category;
      }
      const qsCategory = categorySlug ? '&category=' + categorySlug : '';

      try {
        const res = await saveFiltersMutation({
          variables: {
            alert: {
              querystring: process.browser
                ? window.location.search + qsCategory
                : null,
              filter: filters,
              title: generateTitle(filters),
            },
          },
        });

        const {
          data: {
            saveAlert: { filter = false },
          },
        } = res || {};
        //if (_.get(res, 'data.saveAlert.filter', false)) {
        if (filter) {
          const successMsg = (
            <div>
              <strong>{t('search.alert.success.title')}</strong>
              <br />
              {t('search.alert.success.message')}
            </div>
          );
          addToast(successMsg, {
            appearance: 'success',
            autoDismiss: true,
          });

          if (typeof window !== 'undefined' && analytics) {
            // create analytics event
            analytics.logEvent('alert_add', {
              title: generateTitle(filters),
              filter: filters,
            });
          }
        } else {
          addToast('Erreur', { appearance: 'error', autoDismiss: true });
        }
        setSavingFilters(false);
      } catch (error) {
        console.warn('mutation error => ', error);
        setSavingFilters(false);
      }
    } else {
      addToast('Connection requise', { appearance: 'error' });
    }
  };

  const searchPostsData = searchPosts.map(post => {
    return {
      ...post,
    };
  });

  const fetchMoreFunc = () => {
    toggleLoading(true);
    // remove this to avoid refresh page issue with new url annonce/:category
    // setStateToUrl({ page: state.page + 1 });
    fetchMore({
      variables: {
        queryVariables: { ...urlState, page: state.page + 1 },
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          toggleLoading(false);
          return prev;
        }
        if (postCount && totalPost) {
          if (postCount <= totalPost) {
            dispatch({
              type: 'UPDATE',
              payload: { ...state, page: state.page + 1 },
            });
            toggleLoading(false);
            return {
              searchPosts: {
                data: [
                  ...prev.searchPosts.data,
                  ...fetchMoreResult.searchPosts.data,
                ],
                total: totalPost,
              },
            };
          }
        }
      },
    });
  };

  const changeAdditionalType = type => e => {
    const { additionalType = '' } = state;

    let newType = '';

    if (additionalType === '') {
      if (type === 'private') {
        newType = 'pro';
      } else {
        newType = 'private';
      }
    }

    ////
    //setCheckboxes( { private : newType === '' || newType === 'private' , pro : newType === '' || newType === 'pro' } ) ;

    pushSearch({ ...state, additionalType: newType });

    dispatch({
      type: 'UPDATE',
      payload: { ...state, additionalType: newType },
    });
  };

  const pushSearch = search => {
    const { category } = search;

    const as = category
      ? `/${SEARCH_PAGE}/${slugify(category)}`
      : `/${SEARCH_PAGE}/all`;

    const url = as + createUrl(cleanParams(search));
    router.push(url, url, { shallow: true });
  };

  useEffect(() => {
    setAppNotReady(false);
  }, [data]);

  useEffect(() => {
    const { additionalType = '' } = state;
    setCheckboxes({
      private: additionalType === '' || additionalType === 'private',
      pro: additionalType === '' || additionalType === 'pro',
    });
  }, [state]);

  const filters = cleanFilters(state);

  const getImageSource = cat => {
    switch (cat) {
      case 'voitures':
        return { img: Car, webp: CarWebp };
      case 'ventes-immobilieres':
        return { img: Immo, webp: ImmoWebp };
      case 'mobilier':
        return { img: Mobilier, webp: MobilierWebp };
      case 'informatique':
        return { img: Computer, webp: ComputerWebp };
      case 'telephonie':
        return { img: Phone, webp: PhoneWebp };
      case 'vetements':
        return { img: Dress, webp: DressWebp };
      case 'sports':
        return { img: Kite, webp: KiteWebp };
      default:
        return null;
    }
  };

  const getCategorySeo = () => {
    if (
      i18n.exists instanceof Function &&
      i18n.exists(
        `${process.env.APP_LOCALIZATION}:search.description.${categorySlug}`
      )
    ) {
      const source = getImageSource(categorySlug);
      const { img, webp } = source || {};
      const sizes = '100px';
      return (
        <div style={{ marginTop: 20, display: 'flex' }}>
          {source && (
            <div
              style={{
                width: 100,
                minWidth: 100,
                height: 100,
                marginRight: 10,
              }}
            >
              <picture>
                <source srcSet={webp.srcSet} sizes={sizes} type="image/webp" />
                <img
                  srcSet={img.srcSet}
                  src={img.src}
                  sizes={sizes}
                  width={100}
                  alt=""
                />
              </picture>
            </div>
          )}

          <div>
            {/*<h4>{t('category.slug.' + categorySlug)}</h4>*/}
            <p style={{ textAlign: 'justify', margin: 0 }}>
              {t(
                `${process.env.APP_LOCALIZATION}:search.description.${categorySlug}`
              )}
            </p>
          </div>
        </div>
      );
    }

    return null;
  };

  if (error) return <OnError />;

  return (
    <SearchWrapper>
      <div className="header">
        <div className="title">
          {!loadingMore && <h1>{getTitle(totalPost)}</h1>}
          {canSaveFilter() && (
            <Button
              iconPosition="left"
              title={t('search.alert.save.btn')}
              fontSize={14}
              disabled={savingFilters}
              className="save-search"
              icon={
                savingFilters ? (
                  <SpinnerLoader
                    color="#00bcd4"
                    width="17px"
                    height="17px"
                    margin="0px 5px 0 0"
                  />
                ) : (
                  <Icon icon={bell} size={20} color="#0B2F3F" />
                )
              }
              onClick={() => saveFiltersAction(filters)}
            />
          )}
        </div>
        {process.env.SEARCH_PRO === '1' && (
          <div className="filter">
            <CheckBox
              id="checkbox-private"
              checked={checkboxes.private}
              labelText={t('search.privates')}
              onChange={changeAdditionalType('private')}
            />
            <CheckBox
              id="checkbox-pro"
              checked={checkboxes.pro}
              labelText={t('search.professionals')}
              className="filterCheckbox"
              onChange={changeAdditionalType('pro')}
            />
          </div>
        )}
        {getCategorySeo()}
      </div>
      {appNotReady && (
        <div>
          <ListLoader />
          <ListLoader />
          <ListLoader />
          <ListLoader />
        </div>
      )}
      {searchPostsData.length === 0 && !loading ? (
        <NoItemFound />
      ) : (
        process.browser && (
          <ListGrid
            data={searchPostsData}
            totalPost={totalPost}
            postCount={postCount}
            buttonText={t('more')}
            className="primary"
            columnWidth={[1]}
            componentContainerStyle={{
              mb: 15,
            }}
            componentWrapperStyle={{
              margin: 0,
            }}
            component={(item, i) => {
              return (
                <ListView
                  indexLoop={i}
                  ads={true}
                  size={searchPostsData.length}
                  currency={CURRENCY}
                  title={item.title}
                  additionalType={item.additionalType}
                  price={item.price}
                  category={item.category}
                  id={item.id}
                  sid={item.sid}
                  town={item.town}
                  source={item.media}
                  photos={item.photos}
                  certified={item.certified}
                  description={item.description ? item.description : ''}
                  createdAt={item.updatedAt}
                  userName={item.userName}
                />
              );
            }}
            loading={loadingMore ? loadingMore : loading}
            loaderColor="#ffffff"
            placeholder={
              <div>
                <ListLoader />
                <ListLoader />
                <ListLoader />
              </div>
            }
            limit={state.LIMIT}
            handleLoadMore={loading => {
              fetchMoreFunc();
            }}
          />
        )
      )}
    </SearchWrapper>
  );
};

const SearchPost = props => {
  return (
    <Fragment>
      <SearchPostItem {...props} />
    </Fragment>
  );
};

export default SearchPost;
